export default "__VITE_ASSET__CFKqQ5Hd__"